import { Component } from '@angular/core';
import { SharedDataService } from '@teem/app/core/services/shared-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddressModalComponent } from '../../modals/address-modal/address-modal.component';

@Component({
  selector: 'app-action-cards',
  templateUrl: './action-cards.component.html',
  styleUrls: ['./action-cards.component.scss']
})
export class ActionCardsComponent {
  isAddressModalOpen: boolean = false;
  isAccountSettingsModalOpen: boolean = false;
  activeAccountSettingsTab: string = 'general';
  customerInfo: any; 
  constructor(
    private sharedDataService : SharedDataService,
    private modalService: NgbModal,
  ){}

  ngOnInit(): void {
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.customerInfo) {
        this.customerInfo = data.customerInfo
      }
    });
  }

  // openAddressModal(): void {
  //   this.isAddressModalOpen = true;
  // }

  openAddressModal(): void {
    // this.isAddressModalOpen = true;
    const modalRef = this.modalService.open(AddressModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
  }
  
  closeAddressModal(): void {
    this.isAddressModalOpen = false;
  }
  
  openAccountSettingsModal(tab: string): void {
    this.activeAccountSettingsTab = tab;
    this.isAccountSettingsModalOpen = true;
  }
  
  closeAccountSettingsModal(): void {
    this.isAccountSettingsModalOpen = false;
  }
}